import { useState } from "react";
import { saveCompanyLocation } from "../Api/CompanyLocationMaster";
import { Container, Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import Sample14 from "../Components/Logo";

const CompanyLocationMaster = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const userDetails = JSON.parse(localStorage.getItem("userDetails"));
  const userId = userDetails?.userId;

  const [companyLocationData, setCompanyLocationData] = useState({
    registrationNumber: "",
    cityId: "",
    stateId: "",
    companyName: "",
  });

  const handleChange = (e) => {
    setCompanyLocationData({ ...companyLocationData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveCompanyLocation(companyLocationData, userId); 
      toast.success(`🦄 Company Location Added Successfully`);
      setCompanyLocationData({
        registrationNumber: "",
        cityId: "",
        stateId: "",
        companyName: "",
      });
      navigate("/companyLocationMaster");
    } catch (error) {
      toast.error(`🦄 Error saving company location: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
      <div className="main-content expand">
        <Container fluid className="fields-container">
          <h2 className="fields-title">Company Location Master</h2>

          {loading && (
            <div className="loading-overlay">
              <Sample14 />
            </div>
          )}

          <Form onSubmit={handleSubmit} className="fields-form">
            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Registration Number <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="registrationNumber"
                    value={companyLocationData.registrationNumber}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>City ID <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="cityId"
                    value={companyLocationData.cityId}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>State ID <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="stateId"
                    value={companyLocationData.stateId}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row>
              <Col md={4}>
                <Form.Group className="mb-3">
                  <Form.Label>Company Name <span className="text-red">**</span></Form.Label>
                  <Form.Control
                    type="text"
                    name="companyName"
                    value={companyLocationData.companyName}
                    onChange={handleChange}
                    required
                  />
                </Form.Group>
              </Col>
            </Row>

            <div className="fields-btn-container">
              <Button
                variant="primary"
                type="submit"
                className="fields-submit"
                disabled={loading}
              >
                {loading ? "Saving..." : "Save Company Location"}
              </Button>
            </div>
          </Form>
        </Container>
      </div>
  );
};

export default CompanyLocationMaster;
